YAHOO.namespace('gTbl');

_YDom = YAHOO.util.Dom;
_YAnim = YAHOO.util.Anim;
_YEvent = YAHOO.util.Event;
_YSelector = YAHOO.util.Selector;

gTbl = {
	triggerClass: 'show',
	init: function() {
		var listitems, i, content;
		var x = document.getElementById('AwapLeft');
		gTbl.indexes = document.getElementById('AwapLeft');
		if (!gTbl.indexes) {
			return;
		}

		listitems = _YSelector.query('.wapWidget span.collapseIcon');
		hidableContentItems = _YDom.getElementsByClassName('hidableContent');
		for (i = 0; i < listitems.length; i++) {
			listitems[i].content = hidableContentItems[i];
			if (hidableContentItems[i])
				hidableContentItems[i].defaultHeight = hidableContentItems[i].offsetHeight;
		}

		var headerRow = _YSelector.query('.wapWidget span.collapseIcon');
		_YEvent.addListener(headerRow, 'click', gTbl.toggle);

		var gTblProjectRow = _YSelector.query('.gTbl li.sec ul li');
		_YEvent.addListener(gTblProjectRow, 'mouseover', gTbl.changeProjectDifficultyIcon);
		_YEvent.addListener(gTblProjectRow, 'mouseout', gTbl.restoreProjectDifficultyIcon);

		var fTblProjectRow = _YSelector.query('.fTbl li.sec');
		_YEvent.addListener(fTblProjectRow, 'mouseover', gTbl.changeProjectDifficultyIcon);
		_YEvent.addListener(fTblProjectRow, 'mouseout', gTbl.restoreProjectDifficultyIcon);


		var activeContributorClose = _YSelector.query('.activeContributorClose.flat_icon');
		if (activeContributorClose) {
			_YEvent.addListener(activeContributorClose, 'click', gTbl.removeActiveContributorNotice);
		}
	},
	toggle: function() {
		var attributes, anim;
		if (!this || !this.content) {
			return;
		}
		var c = this.content;
		if (!_YDom.hasClass(c, 'shown')) {
			_YDom.addClass(this, 'shown');
			_YDom.addClass(c, 'shown');
			attributes = {
				height: { from: 0, to: c.defaultHeight }
			};
			anim = new _YAnim(c, attributes, 0.3, YAHOO.util.Easing.easeOut);
			anim.animate();
			anim.onComplete.subscribe(gTbl.toggleCustom);
		} else {
			_YDom.removeClass(this, 'shown');
			_YDom.removeClass(c, 'shown');
			attributes = {
				height: { from: c.defaultHeight, to: 0 }
			};
			anim = new _YAnim(c, attributes, 0.3, YAHOO.util.Easing.easeOut);
			anim.animate();
			anim.onComplete.subscribe(gTbl.toggleCustom);
		}
	},
	toggleCustom: function() {
		var c = this.getEl();
		c.shown = c.shown ? false : true;
	},
	hideContents: function() {
		_YDom.addClass('AwapLeft', 'dynTbl');
		var lastItem = _YSelector.query('li.sec ul li:last-child');
		_YDom.setStyle(lastItem, 'borderBottom', 'none');
		var firstSet = _YSelector.query('li.sec h1:first-child');
		_YDom.setStyle(firstSet, 'borderTop', 'none');

		var lastFTblItem = _YSelector.query('.BlogPost:last-child');
		_YDom.setStyle(lastFTblItem, 'borderBottom', 'none');
		gTbl.init();
	},

	changeProjectDifficultyIcon: function() {
		var item;
		var itemChildren = _YDom.getChildren(this);
		for (i = 0; i < itemChildren.length; i++) {
			item = itemChildren[i];
			if (_YDom.hasClass(item, 'projectDiffText')) {
				_YDom.setStyle(item, 'display', 'inline-block');
			}
			if (_YDom.hasClass(item, 'projectDiffIcon')) {
				_YDom.setStyle(item, 'display', 'none');
			}
		}
	},

	restoreProjectDifficultyIcon: function() {
		var item;
		var itemChildren = _YDom.getChildren(this);
		for (i = 0; i < itemChildren.length; i++) {
			item = itemChildren[i];
			if (_YDom.hasClass(item, 'projectDiffText')) {
				_YDom.setStyle(item, 'display', 'none');
			}
			if (_YDom.hasClass(item, 'projectDiffIcon')) {
				_YDom.setStyle(item, 'display', 'inline-block');

			}
		}
	},

	removeActiveContributorNotice: function() {
		var activeContributorDiv = _YDom.getElementsByClassName('activeContributorDiv');
		if (activeContributorDiv) {
			_YDom.setStyle(activeContributorDiv, 'display', 'none');
		}

		//Set a cookie that says that we removed the active contributor notice.
		var expiry = new Date();
		// move forward 90 days
		expiry.setTime(expiry.getTime() + 1000 * 60 * 60 * 24 * 90);
		document.cookie = "AWAPACNoteRemoved" + "=" + escape("true") + "; expires=" + expiry.toUTCString() + "; path=/";
	},

	showWhatsThisModal: function(header, body) {
		gTbl.whatsThisHeader = header;
		gTbl.whatsThisBody = body;
		$Anc.load({ type: 'AncModal', onSuccess: gTbl.displayWhatsThisModal });
	},

	displayWhatsThisModal: function(config) {
		if (gTbl.whatsThisInfoModal === null) {
			gTbl.whatsThisInfoModal = new $Anc.Modal({ id: "whatsThisInfoModal" });
		}
		gTbl.whatsThisInfoModal.setHeader(gTbl.whatsThisHeader);
		gTbl.whatsThisInfoModal.setBody(gTbl.whatsThisBody);
		gTbl.whatsThisInfoModal.render();
		gTbl.whatsThisInfoModal.show();
	}
};


gTbl.whatsThisInfoModal = null;

_YEvent.onDOMReady(gTbl.init);

// Track the keying tool "launch" button
AWAPKeyingTool = {
	TrackLaunch: function() {
		s = s_gi(s_account);
		s.pageName = 'AWAP:LaunchKeyingTool';
		s_pageName = s.pageName;
		s.t();
	}
};